import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMyShares } from '@lf/api-client/lfApiShare';

function formatDate(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString();
    } catch (_) {
        return iso;
    }
}

function expiryLabel(share) {
    if (share.expired) return 'expired';
    if (!share.expires_at) return '';
    try {
        const now = Date.now();
        const exp = new Date(share.expires_at).getTime();
        const diffMs = exp - now;
        if (diffMs <= 0) return 'expired';
        const days = Math.ceil(diffMs / (24 * 60 * 60 * 1000));
        return `expires in ${days}d`;
    } catch (_) {
        return '';
    }
}

const MySharedPlans = () => {
    const [shares, setShares] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            const data = await getMyShares();
            if (cancelled) return;
            setShares((data && data.shares) || []);
        };
        load();
        return () => { cancelled = true; };
    }, []);

    if (shares === null) {
        return <div className="text-gray-600">Loading...</div>;
    }

    return (
        <div>
            <div className="mb-4">
                <button
                    className="text-gray-500 hover:underline py-2"
                    onClick={() => navigate('..')}>
                    ← Back
                </button>
            </div>

            <h1 className="text-xl font-semibold mb-4">My shared study plans</h1>

            {shares.length === 0 ? (
                <p className="text-gray-600">You haven't shared any study plans yet.</p>
            ) : (
                <table className="border border-gray-200 w-full text-sm">
                    <thead className="bg-green-700 text-white">
                        <tr>
                            <th className="font-normal p-2 text-left">Title</th>
                            <th className="font-normal p-2 text-left">Created</th>
                            <th className="font-normal p-2 text-left">Status</th>
                            <th className="font-normal p-2 text-right">Imports</th>
                        </tr>
                    </thead>
                    <tbody>
                        {shares.map((share) => (
                            <tr key={share.share_id} className="border border-gray-200 bg-white">
                                <td className="p-2">{share.snapshot_title}</td>
                                <td className="p-2">{formatDate(share.created_at)}</td>
                                <td className="p-2">
                                    <span className={`inline-block px-2 py-0.5 rounded text-xs ${
                                        share.expired
                                            ? 'bg-gray-200 text-gray-700'
                                            : 'bg-green-100 text-green-800'
                                    }`}>
                                        {expiryLabel(share)}
                                    </span>
                                </td>
                                <td className="p-2 text-right">{share.import_count || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default MySharedPlans;
